import {
  EEmptyListingSuggestionsActionType,
  TEmptyListingSuggestionsFailure,
  TEmptyListingSuggestionsRequest,
  TEmptyListingSuggestionsSuccess,
} from './types';
import { resetTerms, TJsonQuery } from '../../../../packages/JsonQuery';
import { IOfferForMobileSiteSchema } from '../../repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { selectJsonQuery } from '../../selectors/filters';
import { selectVisibleListingOffers } from '../../selectors/listingOffers';
import { fetchEmptyListingSuggestions } from '../../services/emptyListingSuggestions';
import { TThunkAction } from '../../types/redux';
import { getJsonQueryWithoutRequestOnlyTerms } from '../../utils/jsonQuery/getJsonQueryWithoutRequestOnlyTerms';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const requestEmptyListingSuggestions: () => TEmptyListingSuggestionsRequest =
  actionGenerator<EEmptyListingSuggestionsActionType.Request>(EEmptyListingSuggestionsActionType.Request);

export const successEmptyListingSuggestions: (offers: IOfferForMobileSiteSchema[]) => TEmptyListingSuggestionsSuccess =
  actionGenerator<EEmptyListingSuggestionsActionType.Success, IOfferForMobileSiteSchema[]>(
    EEmptyListingSuggestionsActionType.Success,
  );

export const failureEmptyListingSuggestions: () => TEmptyListingSuggestionsFailure =
  actionGenerator<EEmptyListingSuggestionsActionType.Failure>(EEmptyListingSuggestionsActionType.Failure);

// Защита от гонок: учитываем только ответ последнего запроса (паттерн listingRequestGeneration).
let suggestionsRequestGeneration = 0;

/**
 * Загрузка рекомендаций для пустой выдачи десктопа.
 * Единственный вызов — эффект в EmptyListingSuggestionsContainer (показ empty-стейта
 * при видимом сайдбаре); контейнер существует только в десктопном дереве.
 */
export const loadEmptyListingSuggestions = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const generation = ++suggestionsRequestGeneration;

  dispatch(requestEmptyListingSuggestions());

  try {
    // География — частая причина пустой выдачи: рекомендации ищем без привязки к пустой области.
    const jsonQueryWithoutRequestOnlyTerms = getJsonQueryWithoutRequestOnlyTerms(
      selectJsonQuery(getState()) as TJsonQuery,
    );
    const jsonQuery = resetTerms(['bbox'])(jsonQueryWithoutRequestOnlyTerms);

    const offers = await fetchEmptyListingSuggestions(context, {
      jsonQuery,
      offerIds: [],
      page: 1,
      subdomain: context.custom.subdomain,
    });

    const isStaleRequest = generation !== suggestionsRequestGeneration;
    const hasListingOffers = selectVisibleListingOffers(getState()).length > 0;
    if (isStaleRequest || hasListingOffers) {
      return;
    }

    dispatch(successEmptyListingSuggestions(offers));
  } catch {
    // Сервис уже залогировал ошибку и пробросил — рекомендации просто не покажутся.
    const isStaleRequest = generation !== suggestionsRequestGeneration;
    if (isStaleRequest) {
      return;
    }

    dispatch(failureEmptyListingSuggestions());
  }
};
